import React, {useEffect, useState} from "react";
import ProductsQuantity from "components/Header/ProductsQuantity";
import Loader from "components/Loader";
import Content from "./Content";
import TagManagerService from "services/TagManager";
import PubSub from "services/PubSub/";
import {hasClass, addClass, removeClass} from "utils";
import PropTypes from "prop-types";
import style from './style.scss'; //NOSONAR

let actions = [];

const MiniCart = (props) => {
    const {orderForm, loading, partialLoading} = props;
    const [openCart, setOpenCart] = useState(false);

    useEffect(() => {
        actions.push(PubSub.register('toggle_minicart', clickMenuMobile));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = []
        }
    }, []);

    const clickMenuMobile = (payload = false) => {
        if (payload.value) {
            setOpenCart(payload.value.state);
        }
    };

    const clickCart = () => {
        if (!openCart) {
            TagManagerService.clickHeader('carro', 'header');
        }

        PubSub.dispatch('close_tracking');

        const opened = !openCart;
        setOpenCart(opened);

        PubSub.dispatch('toggle_menu', { state: false });
        PubSub.dispatch('toggle_notify', { state: false });

        if (typeof window !== 'undefined' && window.innerWidth <= 860) {

            if (!hasClass(document.querySelector('.new-header-cont-minicart'), "open")) {
                addClass(document.documentElement, 'non-scroll');
            } else {
                removeClass(document.documentElement, 'non-scroll');
            }
        }
    };

    const quantity = orderForm ? orderForm.items.reduce((accumulator, item) => {
        return accumulator + item.quantity;
    }, 0) : 0;


    return <div className={'new-header-cont-minicart' + (openCart ? ' open' : '')} >
        <button type="button" className="new-header-btn-minicart" onClick={clickCart} aria-label="Cart button">
            {!partialLoading && <span className="font-icn cart header-cart" />}
            {quantity > 0 && !partialLoading && <div className={!partialLoading ? "new-header-cartQty" : "remove-item"}>
                <ProductsQuantity quantity={quantity} />
            </div>}
            {partialLoading &&
            <div className="new-button-loader-wrapper">
                <Loader />
            </div>}
        </button>
        <Content orderForm={orderForm} quantity={quantity} loading={loading} />
    </div>;
};

MiniCart.propTypes = {
    loading: PropTypes.bool,
    orderForm: PropTypes.object,
    partialLoading: PropTypes.bool
};

export default MiniCart;
